import React, { ChangeEvent } from 'react';
import { useReportContext } from '../../../../_context/ReportContext';
import { ClientType } from '../../../../_models/Client.model';
import "../../../Admin/AddUsers/AddUsers.css";
import "../../Reports.css";

export const ClientAndClientComments = () => {
  const { newReport, setNewReport } = useReportContext();
  const isNDISReport = newReport.Client.Type === ClientType.NDIS;

  const handleClientRemarksChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
    setNewReport({ ...newReport, ClientRemarks: event.target.value });
  };

  const handleCNARemarksChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
    setNewReport({ ...newReport, CNARemarks: event.target.value });
  };

  return (
    <div className="reports-page-wrapper" style={{ maxWidth: 800 }}>
      {/* Header */}
      <div className="rp-client-header" style={{ background: "linear-gradient(135deg, #1e3a8a 0%, #312e81 100%)" }}>
        <h2 className="rp-client-title">Step 5: Remarks & Comments</h2>
        <div className="rp-client-email" style={{ marginTop: 4 }}>
          Final observations before signing off
        </div>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "24px" }}>

        {/* Client Remarks Card */}
        <div className="au-card">
          <div className="au-card-body" style={{ padding: "24px" }}>
            <h3 style={{ fontSize: "1.05rem", fontWeight: 700, color: "#0f1c34", marginBottom: "16px" }}>
              {isNDISReport ? 'Client Remarks / Complaints' : 'Client Comments'}
            </h3>
            <div className="form-group-class">
              <textarea
                rows={6}
                placeholder={isNDISReport ? 'Enter any client remarks or complaints here...' : 'Enter client comments here...'}
                value={newReport.ClientRemarks || ''}
                onChange={handleClientRemarksChange}
                style={{
                  width: "100%",
                  border: "1px solid #E5E7EB",
                  borderRadius: "8px",
                  padding: "16px",
                  fontSize: "0.95rem",
                  outline: "none",
                  resize: "vertical",
                  boxShadow: "inset 0 1px 2px rgba(0,0,0,0.02)",
                  transition: "border-color 0.15s ease"
                }}
                onFocus={(e) => e.target.style.borderColor = "#2563C0"}
                onBlur={(e) => e.target.style.borderColor = "#E5E7EB"}
              />
            </div>
          </div>
        </div>

        {/* CNA Remarks Card */}
        <div className="au-card">
          <div className="au-card-body" style={{ padding: "24px" }}>
            <h3 style={{ fontSize: "1.05rem", fontWeight: 700, color: "#0f1c34", marginBottom: "16px" }}>
              CNA Comments
            </h3>
            <div className="form-group-class">
              <textarea
                rows={6}
                placeholder="Enter CNA comments or internal notes here..."
                value={newReport.CNARemarks || ''}
                onChange={handleCNARemarksChange}
                style={{
                  width: "100%",
                  border: "1px solid #E5E7EB",
                  borderRadius: "8px",
                  padding: "16px",
                  fontSize: "0.95rem",
                  outline: "none",
                  resize: "vertical",
                  boxShadow: "inset 0 1px 2px rgba(0,0,0,0.02)",
                  transition: "border-color 0.15s ease"
                }}
                onFocus={(e) => e.target.style.borderColor = "#2563C0"}
                onBlur={(e) => e.target.style.borderColor = "#E5E7EB"}
              />
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};
